import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from '../shared/Button';
export const TrustedBySection = () => {
  const companies = ['Google', 'Meta', 'Apple', 'Airbnb', 'Amazon', 'Databricks', 'Stripe'];
  return <section id="trusted-by" className="w-full bg-[#231232]/50 backdrop-blur-md py-16 border-t border-b border-[#6805DA]/20 scroll-mt-24" data-id="element-307">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-308">
        <div className="text-center mb-10" data-id="element-309">
          <h3 className="text-white font-outfit text-2xl font-bold mb-4" data-id="element-310">
            Engineers from top companies trust ApplyPass
          </h3>
          <div className="h-1 w-24 bg-gradient-to-r from-[#FFC501] to-[#DF4425] mx-auto rounded-full mb-8" data-id="element-311"></div>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-8" data-id="element-312">
          {companies.map(company => <span key={company} className="text-2xl sm:text-3xl font-outfit font-bold text-gray-200 opacity-80 hover:opacity-100 transition-opacity" data-id="element-313">
              {company}
            </span>)}
          <span className="text-xl sm:text-2xl font-outfit font-bold text-gray-200 opacity-70" data-id="element-314">
            and more
          </span>
        </div>
        <div className="mt-14 text-center" data-id="element-315">
          <Button variant="outline" className="inline-flex items-center gap-2 font-medium" href="#testimonials" data-id="element-316">
            See Client Success Stories <ArrowRightIcon size={18} data-id="element-317" />
          </Button>
        </div>
      </div>
    </section>;
};